function makeTriggerId(baseId, value) {
  return `${baseId}-trigger-${value}`;
}
function makeContentId(baseId, value) {
  return `${baseId}-content-${value}`;
}

export { makeContentId as a, makeTriggerId as m };
//# sourceMappingURL=utils.js.map
